<template>
  <ym-popup class="qrcode-popup"
            v-model="visible"
  >
    <div class="qrcode-popup-title" v-html="title"></div>
    <div class="qrcode-popup-image">
      <img :src="qrcode"
           alt="qrcode"
      />
    </div>
  </ym-popup>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'QrCodePopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      qrcode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .qrcode-popup {
    width: 600px;
    height: 674px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 130px;
    box-sizing: border-box;
    &-title {
      color: #e74933;
      font-size: 34px;
      text-align: center;
      line-height: 45px;
    }
    @contact-image-size: 260px;
    &-image {
      width: 474px;
      height: 474px;
      text-align: center;
      margin-top: 70px;
      img {
        width: @contact-image-size;
        height: @contact-image-size;
        -webkit-touch-callout: none;
        z-index: 9;
      }
    }
  }
</style>
